import {
    Avatar,
    Checkbox,
    CloseIcon,
    Dialog,
    Divider,
    Flex,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";

import {
    CalendarClockRegular,
    PeopleTeam16Filled,
    BuildingBank16Filled,
} from "@fluentui/react-icons";
import { useAuthDetailStore } from "../../../stores/useAuthStore";
import BadgeIcon from "../../BadgeIcon";
import { CustomBadge } from "../../Badge";
import { Doughnut } from "react-chartjs-2";
import { useState } from "react";

const HeaderUser = () => {
    const detail = useAuthDetailStore((state) => state.detail);
    const fullname = `${detail?.first_name} ${detail?.last_name}`;
    return (
        <Flex gap="gap.medium">
            <Flex gap="gap.small" vAlign="center">
                <Avatar name={fullname} size="largest" image={detail.avatar} />
            </Flex>
            <Flex gap="gap.small" vAlign="center" column>
                <Flex column gap="gap.smaller">
                    <STextFullname content={fullname} />
                    <SJobTitle content={detail.job_title} />
                </Flex>
                <Flex gap="gap.medium">
                    <BadgeIcon
                        icon={<PeopleTeam16Filled color=" #616161" />}
                        content={detail.department.name}
                    />
                    <BadgeIcon
                        icon={<BuildingBank16Filled color=" #616161" />}
                        content={detail.agency.name}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

const GraphRecovery = ({
    actualSolde,
    totalAcquired,
    compensated,
    hoursCountPerDay,
    actualSoldeInDays,
    totalAcquiredInDays,
    compensatedInDays,
}) => {
    const [showInDays, setShowInDays] = useState(false);

    const fActualSolde = showInDays ? actualSoldeInDays : actualSolde + " h";
    const fCompensated = showInDays
        ? compensatedInDays + " j"
        : compensated + " h";

    const fTotalAcquired = showInDays
        ? totalAcquiredInDays
        : totalAcquired + " h";

    // calcul pour le graph
    const g_componsated = (compensated * 100) / actualSolde;
    const g_actualSolde = 100 - g_componsated;
    return (
        <Flex gap="gap.large">
            <Flex
                styles={{
                    width: "226px",
                    position: "relative",
                }}
            >
                <GraphBadge>
                    <CustomBadge
                        bg="rgba(41, 40, 40, 0.90)"
                        color="white"
                        label={`1 j = ${hoursCountPerDay} h`}
                        rectangular
                        styles={{
                            borderRadius: "4px",
                        }}
                    />
                </GraphBadge>
                <Doughnut
                    data={{
                        labels: ["Actuel", "Compensées"],
                        datasets: [
                            {
                                label: "",
                                data: [g_actualSolde, g_componsated],
                                backgroundColor: ["#6264A7", "#DFDEDE"],
                                borderColor: ["#6264A7", "#DFDEDE"],
                                borderWidth: 1,
                            },
                        ],
                    }}
                    options={{
                        responsive: true,
                        maintainAspectRatio: true,
                        aspectRatio: "1",
                        plugins: {
                            legend: false,
                        },
                        circumference: 180,
                        rotation: -90,
                        cutout: "65%",
                    }}
                />
                <LegendGraph>
                    <Flex
                        vAlign="center"
                        hAlign="center"
                        column
                        gap="gap.smaller"
                    >
                        <SoldeActual content={fActualSolde} weight="bold" />
                        <SoldeActualLabel content="Solde actuel" />
                    </Flex>
                </LegendGraph>
            </Flex>
            <Flex
                fill
                column
                style={{
                    height: "auto",
                    paddingTop: "7px",
                    paddingBottom: "52px",
                }}
            >
                <Flex fill hAlign="end">
                    <div>
                        <Checkbox
                            value={showInDays}
                            onChange={(e, { checked }) =>
                                setShowInDays(checked)
                            }
                            label="Affichage en jours"
                            toggle
                        />
                    </div>
                </Flex>
                <Flex column fill styles={{ gap: "8px" }}>
                    <Flex space="between">
                        <Label content="Total heures acquises" />
                        <Hours content={fTotalAcquired} />
                    </Flex>
                    <Flex column styles={{ gap: "2px" }}>
                        <Flex space="between">
                            <Label
                                content={
                                    <Flex vAlign="center" gap="gap.smaller">
                                        <Color $name="#DFDEDE" />
                                        <Label content="Heures compensées" />
                                    </Flex>
                                }
                            />
                            <Hours content={fCompensated} />
                        </Flex>
                        <Divider />
                        <Flex space="between">
                            <Label
                                content={
                                    <Flex vAlign="center" gap="gap.smaller">
                                        <Color $name="#6264A7" />
                                        <Label content="Solde actuel" />
                                    </Flex>
                                }
                            />
                            <Hours content={fActualSolde} />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};

const DialogRecoveryYearly = ({
    actualSolde,
    totalAcquired,
    compensated,
    hoursCountPerDay,
    actualSoldeInDays,
    totalAcquiredInDays,
    compensatedInDays,
}) => {
    const [open, setOpen] = useState(false);

    return (
        <Dialog
            open={open}
            content={
                <Flex column gap="gap.small" styles={{ paddingTop: "20px" }}>
                    <HeaderUser />
                    <Divider />
                    <GraphRecovery
                        actualSolde={actualSolde}
                        totalAcquired={totalAcquired}
                        compensated={compensated}
                        hoursCountPerDay={hoursCountPerDay}
                        actualSoldeInDays={actualSoldeInDays}
                        totalAcquiredInDays={totalAcquiredInDays}
                        compensatedInDays={compensatedInDays}
                    />
                </Flex>
            }
            trigger={
                <SLink onClick={() => setOpen(true)}>en savoir plus</SLink>
            }
            header={
                <Flex vAlign="center" gap="gap.small">
                    <CalendarClockRegular />
                    <Text content="Récupération annuelle" weight="bold" />
                </Flex>
            }
            onCancel={() => setOpen(false)}
            headerAction={{
                icon: <CloseIcon />,
                title: "Fermer",
                onClick: () => {
                    setOpen(false);
                },
            }}
        />
    );
};

export default DialogRecoveryYearly;

const Color = styled.div`
    width: 20px;
    height: 16px;
    background-color: ${(props) => props.$name};
`;

const Hours = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const Label = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const SJobTitle = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const STextFullname = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 133.333% */
`;

export const SLink = styled(Text)`
    color: var(--Blue-link, #0067b8);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;

    cursor: pointer;
`;

const GraphBadge = styled.div`
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    margin: auto;
    width: fit-content;
`;

const LegendGraph = styled.div`
    position: absolute;
    bottom: 15%;
    left: 0;
    right: 0;
    margin: auto;
`;

const SoldeActual = styled(Text)`
    color: #6264a7;
    text-align: center;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
`;

const SoldeActualLabel = styled(Text)`
    color: #252424;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 116.667% */
`;
